import { FC } from 'react'
import { GetServerSideProps } from 'next'

import LibrarySearchLayout from 'containers/library-layout/library-layout'
import SEOMetatags from 'components/parts/seo-metatags/seo-metatags'
import SEOBreadCrumbs from 'components/parts/seo-metatags/seo-breadcrumbs'
import nestRequest from 'utils/server-side/nestRequest'

import { SEOType } from 'constants/SEO'
import { LibraryPagePodcastBC } from 'constants/SEO-breadcrumbs'
import { INewslineCard } from 'constants/types/card.types'
import { PLACEFLAG_LIBRARY } from 'constants/analytic-data'
import { CARDS_ON_PAGE } from 'constants/search-data/search-data'
import { useARegAndLogin, originReg } from 'utils/analytics/other/registration/registration'

const LibraryPodcastSEO = (page: number) => {
  return {
    [SEOType.TITLE]: `Подкасты про медицину для врачей - Страница ${page}`,
    [SEOType.DESCRIPTION]: `Бесплатные подкасты по медицине для врачей на русском языке от ведущих экспертов - Страница ${page}`,
    [SEOType.LINK]: `${URL}/library/podcast`,
    [SEOType.PLACE]: PLACEFLAG_LIBRARY,
  }
}

interface ILibraryInteractive {
  pageValue: number
  initCards: {
    count: number
    rows: INewslineCard[]
  }
}

const LibraryInteractive: FC<ILibraryInteractive> = ({ pageValue, initCards }) => {
  useARegAndLogin(originReg.LIBRARY)
  return (
    <>
      <SEOMetatags data={LibraryPodcastSEO(pageValue)} />
      <SEOBreadCrumbs data={LibraryPagePodcastBC} />
      <LibrarySearchLayout initCards={initCards} title="Интерактивные клинические случаи" />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  let initCards = null

  const offset = context.query.page ? CARDS_ON_PAGE * (Number(context.query.page) - 1) : 0

  const interactiveSearchParams = {
    offset: offset,
    limit: CARDS_ON_PAGE,
    count: true,
  }

  try {
    const interactiveRequest = await nestRequest(
      context,
      'get',
      `/api/interactive/`,
      interactiveSearchParams
    )
    initCards = interactiveRequest?.data

    if (interactiveRequest.status !== 200) throw new Error('rest request error')
  } catch (err) {
    console.log(err)
    initCards = { count: 0, rows: [] }
  }

  return {
    props: {
      initCards,
      pageValue: context.query.page || 1,
    },
  }
}

export default LibraryInteractive
